// extracted by mini-css-extract-plugin
export var container = "MaterialListItem-module--container--5eb4f";
export var contentWrapper = "MaterialListItem-module--contentWrapper--7d9c5";
export var image = "MaterialListItem-module--image--6ff1a";
export var imgWrapper = "MaterialListItem-module--imgWrapper--1411b";